import Vue from 'vue'
import Vuex, {Store} from 'vuex'
import Api from '@/services/Api'
import _ from 'lodash'
import {User} from '@/models/User'

Vue.use(Vuex)

export interface Message
{
    text: string
    show: boolean
}

export type AppStore = Store<{
    user: User|null,
    messages: Message[],
    settings: object,
}>

export default function createStore(api: Api): AppStore {
    return new Vuex.Store({
        state: {
            user: null as User|null,
            messages: [] as Message[],
            settings: {},
        },
        mutations: {
            setUser(state, user) {
                state.user = user
                api.setUserToken(user.token)
                localStorage.setItem('user', JSON.stringify(user))
            },
            resetUser(state) {
                state.user = null
                api.setUserToken(null)
                localStorage.removeItem('user')
            },
            addMessage(state, text) {
                state.messages = [...state.messages, {text, show: true}]
            },
            setMessageHidden(state, message) {
                message.show = false
                state.messages = [...state.messages]
            },
            setSettings(state, settings) {
                state.settings = settings
                localStorage.setItem('settings', JSON.stringify(settings))
            },
            setSetting(state, [path, value]) {
                const copy = state.settings ? _.cloneDeep(state.settings) : {}
                _.set(copy, _.toPath(path), value)
                state.settings = copy
                localStorage.setItem('settings', JSON.stringify(copy))
            },
        },
        getters: {
            isLoggedIn(state) {
                return !!state.user
            },
        },
        actions: {},
        modules: {},
    })
}
